import { useSoftphone } from '../store/softphone';
import { CallbackOverdueDot } from './CallbackBadge';

interface Props {
  onOpenNav: () => void;
}

export function MobileTopBar({ onOpenNav }: Props): JSX.Element {
  const status = useSoftphone((s) => s.status);

  const tone =
    status === 'ready'
      ? 'bg-emerald-100 text-emerald-700'
      : status === 'on_call'
        ? 'bg-amber-100 text-amber-700'
        : status === 'connecting'
          ? 'bg-blue-100 text-blue-700'
          : status === 'wrap_up'
            ? 'bg-purple-100 text-purple-700'
            : status === 'error'
              ? 'bg-red-100 text-red-700'
              : 'bg-ink-100 text-ink-600';

  return (
    <header className="sm:hidden flex items-center gap-3 border-b border-ink-200 bg-white px-3 h-14 shrink-0">
      <button
        type="button"
        aria-label="Open navigation"
        onClick={onOpenNav}
        className="btn-ghost -ml-1 px-2 py-2 text-xl leading-none"
      >
        ☰
      </button>
      <div className="flex flex-col leading-tight min-w-0">
        <span className="text-sm font-semibold tracking-tight">Marnic</span>
        <span className="text-[10px] uppercase tracking-wider text-ink-500">Dialler</span>
      </div>
      <span className={`badge ml-auto ${tone}`}>{humaniseStatus(status)}</span>
      <CallbackOverdueDot />
    </header>
  );
}

function humaniseStatus(s: string): string {
  switch (s) {
    case 'uninitialized':
      return 'Offline';
    case 'registering':
      return 'Connecting…';
    case 'ready':
      return 'Ready';
    case 'connecting':
      return 'Dialling';
    case 'on_call':
      return 'On call';
    case 'wrap_up':
      return 'Wrap-up';
    case 'error':
      return 'Error';
    default:
      return s;
  }
}
